export default __webpack_public_path__ + "static/20_30-a1e052dce892bfb5d1ee6cd1b4d6ae7c.png";